// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","854":"pdfjs"}[chunkId] || chunkId) + "." + {"544":"632f778c","594":"796dc672","854":"ddcfd63a"}[chunkId] + ".js";
};